module.exports = __webpack_public_path__ + "static/media/Christina_L.ff3c7e80.jpg";